var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-container",style:({'background-image': _vm.containerBackground})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"container",staticClass:"inner-container"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /home/vagrant/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a012b17","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/vagrant/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModelViewer.vue
// module id = null
// module chunks = 